module.exports = __webpack_public_path__ + "img/extended.c12b85d3.png";